import React from 'react';
import { FloatingWhatsApp } from './style'; // Importando seu estilo!

export default function WhatsApp() {
  return (
    <FloatingWhatsApp
      href="https://api.whatsapp.com/send?phone=554230289191"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Falar conosco pelo WhatsApp" // Boa prática de acessibilidade
    >
      <img src={require('../../assets/img/Whats.svg')} alt="Whatsapp Icon" />
    </FloatingWhatsApp>
  );
}
